import { Pipe, PipeTransform } from "@angular/core";

/**
 * Generated class for the GenerateRisklabelPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: "generateRisklabel",
})
export class GenerateRisklabelPipe implements PipeTransform {
  /**
   * Generate the Risk Level based on the Member riskScore input
   */
  transform(riskScore: number) {
    let riskLabel = "";
    if (riskScore) {
      if (riskScore >= 0 && riskScore <= 9) {
        riskLabel = riskScore + " Low ";
      } else if (riskScore > 9 && riskScore <= 15) {
        riskLabel = riskScore + " Moderate ";
      } else if (riskScore > 15 && riskScore <= 20) {
        riskLabel = riskScore + " High ";
      }
    } else if (riskScore === 0) {
      riskLabel = riskScore + " Low ";
    }
    return riskLabel;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/community-bereavement/generate-risklabel.pipe.ts